export default __webpack_public_path__ + "static/media/Emblem_Unranked.ee589f02.webp";